import { Component, OnInit } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';
import { RememberService } from '@app/core/services/remember.service';
import { AcLedgerService, AcLedgerViewGet } from '@app/services/ac-ledger.service';
import { BusinesscoItem, LogisticService } from '@app/services/logistic.service';

@Component({
    selector: 'tt-ac-ledger-view',
    templateUrl: './ac-ledger-view.component.html',
    styleUrls: ['./ac-ledger-view.component.css'],
})
export class AcLedgerViewComponent implements OnInit {
    public get?: AcLedgerViewGet;

    public grid?: GridOptions;

    public companies: BusinesscoItem[] = [];

    public loading = false;

    constructor(
        private datatask: DataTaskService,
        private acLedger: AcLedgerService,
        private logistic: LogisticService,
        private remember: RememberService,
    ) {}

    public onAccountsChanged(_: any) {
        if (!this.get) return;

        this.remember.remember('w_acledgerview.account_nos', this.getAccountNosString(this.get.account_nos!));
        this.readGrid();
    }

    public readGrid() {
        this.loading = true;
        this.grid?.gridfunc?.rebind();
    }

    private async loadGet() {
        this.get = await this.acLedger.getAcLedgerView();
        this.get.account_nos ??= [];
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies();
    }

    private createGrid() {
        this.grid = new Grid().setRememberId('w_acledgerview_grid').setLoadDataFunction({ method: 2786, parameters: () => ({ ...this.get, account_nos: this.getAccountNosString(this.get!.account_nos!) }) });
    }

    public searchAccounts = async ({ value }: { value: string | null }): Promise<any[]> => {
        return this.datatask.Post(3888, { searchtext: value, businessco_no: this.get!.businessco_no });
    };

    private getAccountNosString(accounts: any[]): string {
        return accounts!.reduce((acc, item) => acc + ',' + item.item_id, '').substring(1);
    }

    private async init() {
        this.loadCompanies();
        await this.loadGet();
        this.createGrid();
    }

    ngOnInit(): void {
        this.init();
    }
}
